import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
import { RouterModule } from '@angular/router';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { TreeModule } from 'src/app/core/tree/tree.module';
import { SkeletonModule } from '@syncfusion/ej2-angular-notifications';
import {MatMenuModule} from '@angular/material/menu';
import { CustomExpansionPanelModule } from "../../core/custom-expansion-panel/custom-expansion-panel.module";

@NgModule({
  declarations: [
    SidebarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TooltipModule,
    TreeModule,
    SkeletonModule,
    MatMenuModule,
    CustomExpansionPanelModule,
],
  exports: [
    SidebarComponent
  ]
})
export class SidebarModuleCustom { }
